import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import useAuth from '../../hooks/auth/useAuth';
import '../../styles/auth.css';
import AuthFormItemWrapper from './form-item-wrapper';

type TFields = 'email' | 'password';

interface IFormField {
    error: string;
    value: string;
}

export type TLoginFormFields = Record<TFields, IFormField>;

function Login() {
    const [fields, setFields] = useState<TLoginFormFields>({
        email: {
            error: '',
            value: '',
        },
        password: {
            error: '',
            value: '',
        },
    });

    const auth = useAuth();

    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.get('logouted') === 'true') {
            auth.removeToken();
        } else {
            auth.checkAuth();
        }
    }, []);

    const getFormControlClass = (error: string) => {
        if (error.length > 0) {
            return 'form-control is-invalid';
        }
        return 'form-control';
    };

    const onClick = async () => {
        let errorForm = false;

        setFields(produce(fields, (draft) => {
            const keys = Object.keys(draft) as TFields[];
            keys.forEach((key) => {
                if (fields[key].error.length > 0) {
                    errorForm = true;
                }
                if (fields[key].value === '') {
                    errorForm = true;
                    draft[key].error = 'Поле является обязательным';
                }
            });
        }));

        if (!errorForm) {
            const errorFields = await auth.login(fields.email.value, fields.password.value);
            if (errorFields && typeof errorFields === 'object') {
                setFields(produce(fields, (draft) => {
                    const keys = Object.keys(errorFields) as TFields[];
                    keys.forEach((key) => {
                        draft[key].error = errorFields[key];
                    });
                }));
            }
        }
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>, key: TFields) => {
        setFields(produce(fields, (draft) => {
            draft[key] = {
                error: '',
                value: e.target.value,
            };
        }));
    };

    return (
        <div className="login-page">
            <a className="mb-4 login-app-logo" href="/">
                <Logo />
            </a>
            <div className="card">
                <div className="card-body">
                    <p className="login-box-msg"><b>Авторизация</b></p>
                    <form>
                        <AuthFormItemWrapper error={fields.email.error}>
                            <input
                                type="email"
                                className={getFormControlClass(fields.email.error)}
                                placeholder="Электронная почта"
                                onChange={(e) => onInputChange(e, 'email')}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-envelope" />
                                </div>
                            </div>
                        </AuthFormItemWrapper>
                        <AuthFormItemWrapper error={fields.password.error}>
                            <input
                                type="password"
                                className={getFormControlClass(fields.password.error)}
                                placeholder="Пароль"
                                onChange={(e) => onInputChange(e, 'password')}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-lock" />
                                </div>
                            </div>
                        </AuthFormItemWrapper>
                        <button id="login-btn" className="btn btn-primary col-4 float-right" type="button" onClick={onClick}>Войти</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
